import { render } from "./IconYellowEdit.vue?vue&type=template&id=0b736a54"
const script = {}

import exportComponent from "/var/www/tender_demo/www/spa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__